import React, { ReactNode } from 'react';
import styled from 'styled-components';
import Flex from 'Components/Grid/Flex';
import { useSelector } from 'react-redux';
import { getFullCityInfo } from 'Modules/SearchAddress/selectors';
import { Transitions } from 'theme';
import { colors } from 'constants/colors';
import SocialVKIcon from 'Components/Icon/SocialVK';
import SocialFBIcon from 'Components/Icon/SocialFB';
import SocialINSTIcon from 'Components/Icon/SocialINST';
import SocialTGIcon from 'Components/Icon/SocialTG';
import SocialYouTubeIcon from 'Components/Icon/SocialYouTube';
import { mediaMdDown, mediaSmDown } from 'theme/helpers/css';
import { SocialLinks, WLabel } from 'constants/enums';
import ExternalLink from 'Components/ExternalLink';
import { currentWLabel, selectByWL } from 'utils/wLabel';

export const SOCIALS_LIST_TEST_ID = 'SOCIALS_LIST_TEST_ID';

const wlSocialLinkHoverStyles = selectByWL({
  [WLabel.Default]: `background-color: ${colors.grederlevyLight};`,
  [WLabel.Globus]: `background-color: ${colors.simpleLightOrange};`,
});

const SocialsWrapper = styled(Flex).attrs({ middle: true })`
  width: 310px;
  ${mediaMdDown`
    width: 100%;
    padding-bottom: 24px;
  `}
  ${mediaSmDown`
    padding-bottom: 20px;
  `}
`;

interface ILinkProps {
  bgColor?: string;
}

const SocialLink = styled(ExternalLink)<ILinkProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  transition: ${Transitions.bg};
  background-color: ${({ bgColor }) => bgColor ?? colors.white};
  &:hover {
    ${wlSocialLinkHoverStyles}
  }
  & + & {
    margin-left: 12px;
  }
`;

interface ISocialLink {
  name: SocialLinks;
  link: string;
}

const globusSocialLinks: ISocialLink[] = [
  {
    link: 'https://www.instagram.com/globusru_official/',
    name: SocialLinks.inst,
  },
  {
    link: 'https://vk.com/globusru',
    name: SocialLinks.vkontakte,
  },
  {
    link: 'https://www.youtube.com/user/GlobusRu',
    name: SocialLinks.youtube,
  },
];

const wlSocialIconColor = selectByWL({ [WLabel.Default]: colors.darkBlueGreen, [WLabel.Globus]: colors.black });

const getSocialIcon = (name: SocialLinks): ReactNode =>
  ({
    [SocialLinks.vkontakte]: <SocialVKIcon color={wlSocialIconColor} />,
    [SocialLinks.facebook]: <SocialFBIcon color={wlSocialIconColor} />,
    [SocialLinks.inst]: <SocialINSTIcon color={wlSocialIconColor} />,
    [SocialLinks.youtube]: <SocialYouTubeIcon color={wlSocialIconColor} />,
    [SocialLinks.telegram]: <SocialTGIcon color={wlSocialIconColor} />,
  }[name]);

const SocialsList = ({ bgColor }: { bgColor?: string }) => {
  const city = useSelector(getFullCityInfo);

  return (
    <SocialsWrapper data-testid={SOCIALS_LIST_TEST_ID}>
      {currentWLabel === WLabel.Default &&
        city?.social_networks?.map(({ link, name }) => (
          <SocialLink key={name} href={link} newTab bgColor={bgColor}>
            {getSocialIcon(name)}
          </SocialLink>
        ))}
      {currentWLabel === WLabel.Globus &&
        globusSocialLinks.map(({ link, name }: ISocialLink) => (
          <SocialLink key={name} href={link} newTab>
            {getSocialIcon(name)}
          </SocialLink>
        ))}
    </SocialsWrapper>
  );
};

export default SocialsList;
